<template>
  <div>
    <usernav></usernav>
    <el-col v-if="loading" class="C-PageLoading">
      <div class="Spinner spinner-grow text-primary"></div>
    </el-col>
    <div v-if="!loading">
      <el-col :md="12" >
      <el-card style="width: 100%" shadow="never" :body-style="{margin: '0px',padding: '0px', height:'260px', textAlign:'left'}">
        <div class="G-Title">
          {{username}}，欢迎登录
        </div>
        <div class="Profile">
          <span>积分：</span>
          <span>{{integral}}</span>
        </div>
        <div class="Profile">
          <span>会员等级：</span>
          <span style="color: #f39;font-weight:800">{{grade}}</span>
        </div>
        <div class="Profile">
          <span>会员有效期：</span>
          <span>{{vip_time}}</span>
        </div>
        <div class="Profile">
          <span>待审核信息：</span>
          <span>{{audit}}</span>
        </div>
        <div class="Profile">
          <span>已发布信息：</span>
          <span>{{success}}</span>
        </div>
        <div class="Profile">
          <span>已拒绝信息：</span>
          <span>{{refuse}}</span>
        </div>
      </el-card>
      </el-col>
    <el-col :md="12">
      <el-card style="width: 100%" shadow="never" :body-style="{margin: '0px',padding: '0px', height:'260px', textAlign:'left'}">
        <div class="userbtn">
          <router-link to="/publish" tags="div" style="padding-right: 20px">
            <el-button plain size="small"><span style="font-size: 14px">发布赚积分</span></el-button>
          </router-link>
          <router-link to="/upgrade" tags="div">
            <el-button plain size="small"><span style="font-size: 14px">购买/兑换VIP</span></el-button>
          </router-link>
        </div>
        <div>
          <el-table
            :data="tableData"
            border
            style="width: 90%;margin: auto">
            <el-table-column
              prop="title"
              label="类型"
              >
            </el-table-column>
            <el-table-column
              prop="price"
              label="价格"
              >
            </el-table-column>
            <el-table-column
              prop="info"
              label="查看内容">
            </el-table-column>
            <el-table-column
              prop="days"
              label="有效期">
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-col>
    </div>
  </div>
</template>

<script>
import Usernav from '../base/header/usernav'
import {request} from '../../network/request'
export default {
  name: 'usercenter',
  components: {Usernav},
  data () {
    return {
      tableData: [],
      username: '',
      integral: '',
      grade: '',
      audit: '',
      success: '',
      refuse: '',
      vip_time: '',
      loading: true
    }
  },
  created () {
    this.get_user()
  },
  methods: {
    get_user () {
      request({
        url: '/api/usercenter',
        method: 'post'
      }).then(res => {
        if (res) {
          this.tableData = res.data.commodity
          this.audit = res.data.audit
          this.success = res.data.success
          this.refuse = res.data.refuse
          this.integral = res.data.integral
          this.vip_time = res.data.vip_time
          this.grade = res.data.grade
          this.username = res.data.username
          this.loading = false
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  .userbtn {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
  }
  .el-card {
    margin-bottom: 0px;
  }
  .G-Title {
    box-sizing: border-box!important;
    border-bottom: 1px solid #f2f2f2!important;
  }
  .Profile{
    padding-left: 10px;
    margin-top: 15px !important;
    margin-bottom: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/usercenter.vue